module.exports = __webpack_public_path__ + "img/vi.b2e7ec5d.png";